export const PAYMENT_METHODS = {
  BANK: 'bank',
  BANK_TRANSFER: 'bonifico',
  FINANCING: 'finanziamento',
  FINDOMESTIC_FINANCING: 'finanziamento_findomestic',
  NONE: 'none',
}

export const CURRENCY_CODE = 'EUR'
